/* tslint:disable */
require('./TaxonomyRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_48bcb079',
  term: 'term_48bcb079',
  relative: 'relative_48bcb079',
  fabricIcon: 'fabricIcon_48bcb079',
};

export default styles;
/* tslint:enable */